export default {
  reset_password_title: "Restablecer contraseña",
  reset_pass_desc:
    "Por favor ingrese su dirección de correo electrónico y le enviaremos un enlace para restablecer su contraseña.",
  reset_pass: "Restablecer contraseña",
  reset_pass_requested: "Solicitud de restablecimiento de contraseña recibida",
  reset_pass_check_email:
    "Por favor revise su correo electrónico y siga las instrucciones para restablecer su contraseña.",
  reset_pass_email_sent_info:
    "Si este correo electrónico existe en nuestro sistema, se ha enviado un enlace de restablecimiento de contraseña.",
  reset_pass_did_not_receive:
    "¿No recibió el correo electrónico? Por favor revise su carpeta de spam.",
  reset_pass_resend_email: "Reenviar correo de restablecimiento de contraseña",
  reset_pass_resend_available_in: "Reenvío disponible en {seconds} segundos",
  reset_pass_resending: "Reenviando...",
  reset_pass_resent_success: "Correo de restablecimiento de contraseña reenviado con éxito",
  reset_pass_please_wait: "Por favor espere {seconds} segundos antes de reenviar",
  reset_pass_request_failed: "Error en la solicitud de restablecimiento de contraseña",
  email_required: "Por favor ingrese su dirección de correo electrónico",
  email_invalid: "Por favor ingrese una dirección de correo electrónico válida",
  email_placeholder: "su{0}ejemplo.com",
  daily_limit_reached: "Límite diario de reenvío alcanzado. Por favor intente mañana.",
  remaining_attempts: "{count} intentos restantes hoy",
};
